import { PluginConfigs } from '../../plugin-configs';
import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Heartbeat Plugin.
 *
 * @remarks
 * The plugin is enabled via the remote configuration for applicable clients.
 *
 * Be aware that most of the parameters are required by the plugin, so if some values are missing,
 * the plugin will not work as expected and should be disabled.
 */
export const addHeartbeatPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const heartbeat = 'foundation.plugin.heartbeat';
  const { remoteConfig } = partialBuilderConfig;

  const enabled =
    typeof pluginConfigs[heartbeat]?.enabled === 'boolean'
      ? pluginConfigs[heartbeat].enabled
      : remoteConfig.heartbeat?.enable;

  if (!enabled) {
    return pluginConfigs;
  }

  const config = {
    ...pluginConfigs[heartbeat],
    endpoint: pluginConfigs[heartbeat]?.endpoint || remoteConfig.heartbeat?.endpoints,
    offer: pluginConfigs[heartbeat]?.offer || remoteConfig.heartbeat?.offer,
    videoService: pluginConfigs[heartbeat]?.videoService || remoteConfig.heartbeat?.videoService,
    enabled,
  };

  if (!config.endpoint || !config.offer || !config.videoService) {
    // eslint-disable-next-line no-console
    console.warn('Could not activate Heartbeat Tracking because of invalid parameters.', config);
    return pluginConfigs;
  }

  return {
    ...pluginConfigs,
    [heartbeat]: config as PluginConfigs['foundation.plugin.heartbeat'],
  };
};
